<template>
  <div class="box-img-13">
    <img class="bg-img" :src="require('$img/card-bg-13.jpg')" alt="" />
    <div class="company" v-if="info.company">
      <img
        v-if="info.company.logo !== ''"
        :src="info.company.logo + '?imageView2/1/w/100/h/100/q/100'"
        alt=""
      />
      <div class="company-name">
        {{
          info.company.short_name !== ""
            ? info.company.short_name
            : info.company.name
        }}
      </div>
    </div>

    <div class="txt-box">
      <div class="line-box">
        <div class="l-b-t">
          <div>岗位</div>
        </div>

        <div class="l-b-big" style="">
          {{ info.post }}
        </div>
        <div class="l-b-tag" v-if="info.feature">
          <template v-for="(item, index) in featureTxt">
            <div v-if="index < 3" :key="index">
              {{ item }}
            </div>
          </template>
        </div>
      </div>

      <div class="line-box project" style="width:190px">
        <div class="l-b-t">
          <div>项目/公司</div>
        </div>
        <div class="l-b-big" >{{ info.project_name }}</div>
      </div>

      <div class="line-box">
        <div class="l-b-t">
          <div>薪酬待遇</div>
        </div>
        <div class="l-b-big pay">{{ moneyTxt }}</div>
      </div>
      <div v-if="adderTxt" class="line-box">
        <div class="l-b-t">
          <div>工作地点</div>
        </div>
        <div class="l-b-last">{{ adderTxt }}</div>
      </div>
    </div>
    <div class="code">
      <img :src="code" alt="" @load="imgLoad" />
      <p>微信扫码看详情</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card13",
  props: ["info", "code"],
  computed: {
    featureTxt() {
      let txt = this.info.feature.split(",");
      return txt;
    },
    moneyTxt() {
      let str = "";
      if (this.info.treatment_min && !this.info.treatment_max) {
        str = this.info.treatment_min + "k/月";
      } else if (!this.info.treatment_min && this.info.treatment_max) {
        str = this.info.treatment_max + "k/月";
      } else if (this.info.treatment_min && this.info.treatment_max) {
        str = this.info.treatment_min + "k-" + this.info.treatment_max + "k/月";
      }
      if (this.info.treatment.length > 0) {
        if (this.info.treatment.length >= 30) {
          str = str + " " + this.info.treatment.substring(0, 30);
          return str + "...";
        } else {
          str = str + " " + this.info.treatment;
        }
      }
      return str;
    },
    adderTxt() {
      // let adder = this.info.project_address.split(',')
      // let adderArr = adder.filter(val => val !== '-')
      // return adderArr.join('-')
      let adderArr = this.info.province + "-" + this.info.city;
      if (this.info.area) adderArr = adderArr + "-" + this.info.area;
      if (this.info.plate) adderArr = adderArr + "-" + this.info.plate;
      if (this.info.project_address != "-" && this.info.project_address)
        adderArr = adderArr + "-" + this.info.project_address;
      if (adderArr.length >= 28) {
        adderArr = adderArr.substring(0, 28);
        return adderArr + "...";
      }
      return adderArr;
    },
    projectTxt() {
      let project_name = this.info.project_name;
      if (project_name.length >= 9) {
        project_name = project_name.substring(0, 9);
        return project_name + "...";
      }
      return project_name;
    },
  },
  methods: {
    imgLoad() {
      this.$emit("codeImgLoad");
    },
  },
};
</script>

<style lang="scss">
@import "$styles/global.scss";

.box-img-13 {
  width: 600px;
  height: 1300px;
  position: relative;
  z-index: 2;

  .bg-img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .company {
    position: absolute;
    top: 30px;
    width: 100%;
    @include flex-box();

    img {
      height: 59;
      width: 59px;
      border-radius: 2px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid rgba(162, 170, 178, 0.3);
    }

    .company-name {
      color: #efcd7d;
      font-size: 19px;
      margin-left: 10px;
    }
  }

  .project {
    position: absolute;
    top: 0;
    left: 400px;
  }
  .txt-box {
    width: 400px;
    padding-left: 34px;
    position: absolute;
    top: 838px;
    left: 0;
    box-sizing: border-box;

    .line-box {
      width: 100%;
      margin-bottom: 48px;
      @include flex-box(flex-start);

      .l-b-t {
        font-size: 21px;
        color: #a38a50;

        font-weight: 400;
        margin-bottom: 6px;
      }

      .l-b-t-border {
        height: 6px;
        width: 100%;
        border-radius: 2px;
        background: linear-gradient(to right, #6dc1f8, #30a9f9);
      }

      .l-b-other {
        width: 100%;
        font-size: 23px;
        color: #fcdbab;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .l-b-tag {
        width: 100%;
        margin-top: 8px;
        @include flex-box(flex-start);
        height: 36px;
        overflow: hidden;

        div {
          padding: 2px 18px 6px 18px;
          background: rgba(239, 205, 125, 0.2);
          border-radius: 2px;
          font-size: 19px;
          color: #efcd7d;
          margin-bottom: 4px;
        }

        div + div {
          margin-left: 10px;
        }
      }

      .l-b-big {
        color: #efcd7d;
        font-size: 23px;
        width: 100%;
        font-weight: 500;
      }
      .pay {
        font-size: 27px;
      }
      .l-b-last {
        width: 100%;
        font-weight: 500;
        font-size: 20px;
        color: #efcd7d;
        box-sizing: border-box;
        padding-right: 40px;
        // @include text-ellipsis(2);
      }
    }
  }

  .code {
    position: absolute;
    bottom: 23px;
    right: 40px;
    text-align: center;
    img {
      width: 156px;
      height: 156px;
      margin-bottom: 11px;
      border-radius: 50%;
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
    }

    p {
      color: #e7e7e7;
      font-size: 19px;
    }
  }
}
</style>
